export default __webpack_public_path__ + "static/media/af.4cfa02bb.svg";